import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Magento full-page-caches Apollo GET queries for 24 hours. `getStores` carries
 * `isOnlineOrderActive`, which is switched during service, so that query has to
 * go out as POST. POST responses are marked no-store.
 */
export function getStoresPostRequest(uri) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!options || options.method !== "GET" || typeof uri !== "string") return null;
  var url = parseGraphqlUrl(uri);
  if (!url) return null;
  var operationName = url.searchParams.get("operationName");
  var query = url.searchParams.get("query");
  var isGetStores = operationName === "getStores" || typeof query === "string" && /^\s*query\s+getStores\b/.test(query);
  if (!isGetStores || !query) return null;
  var payload = {
    query,
    operationName: operationName || "getStores",
    variables: parseJsonParam(url.searchParams.get("variables"), {})
  };
  var extensions = parseJsonParam(url.searchParams.get("extensions"), undefined);
  if (extensions !== undefined) payload.extensions = extensions;
  return {
    url: endpointFrom(url, uri),
    options: _objectSpread(_objectSpread({}, options), {}, {
      method: "POST",
      headers: withJsonContentType(options.headers),
      body: JSON.stringify(payload)
    })
  };
}
function parseGraphqlUrl(uri) {
  try {
    return new URL(uri);
  } catch (error) {
    try {
      return new URL(uri, "http://localhost");
    } catch (innerError) {
      return null;
    }
  }
}
function endpointFrom(url, originalUri) {
  if (/^https?:\/\//i.test(originalUri)) return "".concat(url.origin).concat(url.pathname);
  return url.pathname;
}
function parseJsonParam(value, fallback) {
  if (!value) return fallback;
  try {
    return JSON.parse(value);
  } catch (error) {
    return fallback;
  }
}
function withJsonContentType(headers) {
  var next = headersToObject(headers);
  var hasContentType = Object.keys(next).some(key => key.toLowerCase() === "content-type");
  if (!hasContentType) next["content-type"] = "application/json";
  return next;
}
function headersToObject(headers) {
  if (!headers) return {};
  if (typeof headers.forEach === "function") {
    var next = {};
    headers.forEach((value, key) => {
      next[key] = value;
    });
    return next;
  }
  return _objectSpread({}, headers);
}